<template>
  <div class="exam-detail">
    <div class="exam-detail-layout" v-if="content">
      <!-- 左侧成绩面板 -->
      <aside class="score-panel">
        <div class="score-card">
          <div class="score-ring" :class="scoreLevel">
            <span class="score-num">{{ showScore ? content.score : '--' }}</span>
            <span class="score-unit" v-if="showScore">分</span>
          </div>
          <p class="score-title">考试成绩</p>
        </div>
        <div class="score-stats">
          <div class="stat-item stat-correct">
            <span class="stat-num">{{ correctCount }}</span>
            <span class="stat-label">答对</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item stat-wrong">
            <span class="stat-num">{{ wrongCount }}</span>
            <span class="stat-label">答错</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item stat-total">
            <span class="stat-num">{{ questionList.length }}</span>
            <span class="stat-label">总题数</span>
          </div>
        </div>
        <ul class="meta-list">
          <li>
            <span class="meta-label">开始时间</span>
            <span class="meta-value">{{ content.created_at || '--' }}</span>
          </li>
          <!-- <li>
            <span class="meta-label">结束时间</span>
            <span class="meta-value">{{ content.updated_at || '--' }}</span>
          </li> -->
        </ul>
      </aside>

      <!-- 右侧答题详情 -->
      <main class="questions-panel">
        <div class="panel-header">
          <h2 class="panel-title">答题详情</h2>
          <span class="panel-badge">共 {{ questionList.length }} 题</span>
        </div>

        <div
          class="question-card"
          v-for="(timu, timuIndex) in questionList"
          :key="timu.id || timuIndex"
          :class="timu.is_right == 1 ? 'is-correct' : 'is-wrong'"
        >
          <div class="question-head">
            <span class="question-no">{{ timuIndex + 1 }}</span>
            <div class="question-main">
              <p class="question-title">{{ timu.title || timu.question }}</p>
              <div class="question-meta">
                <span class="type-tag">{{ questionTypeText(timu.type) }}</span>
                <span class="mark-tag" v-if="timu.mark != null">{{ timu.mark }} 分</span>
              </div>
            </div>
            <span class="result-badge" :class="timu.is_right == 1 ? 'badge-correct' : 'badge-wrong'">
              {{ timu.is_right == 1 ? '正确' : '错误' }}
            </span>
          </div>

          <div class="options-list">
            <div
              class="option-item"
              v-for="opt in getSelectOptions(timu)"
              :key="opt.key"
              :class="getOptionClass(timu, opt.key)"
            >
              <span class="option-key">{{ opt.key }}</span>
              <span class="option-text">{{ opt.value }}</span>
              <span class="option-flag user-flag" v-if="isOptionSelected(timu, opt.key)">你的选择</span>
              <span class="option-flag answer-flag" v-if="isCorrectOption(timu, opt.key) && timu.is_right == 0">正确答案</span>
            </div>
          </div>

          <div class="question-footer" v-if="timu.is_right == 0">
            <span class="footer-label">正确答案</span>
            <span class="footer-answer">{{ formatAnswer(timu.answer, timu) }}</span>
            <span class="footer-sep">·</span>
            <span class="footer-label">你的答案</span>
            <span class="footer-answer user">{{ formatAnswer(timu.user_answer, timu) || '未作答' }}</span>
          </div>
        </div>

        <div class="empty-questions" v-if="questionList.length === 0">
          暂无答题记录
        </div>
      </main>
    </div>

    <div class="exam-loading" v-else>
      <span class="loading-dot"></span>
      加载中...
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "ExamDetail",
  data() {
    return {
      content: null,
      selectedDta: [],
      typeIndex: "",
    };
  },
  computed: {
    questionList() {
      return Array.isArray(this.selectedDta) ? this.selectedDta : [];
    },
    correctCount() {
      return this.questionList.filter((q) => q.is_right == 1).length;
    },
    wrongCount() {
      return this.questionList.filter((q) => q.is_right == 0).length;
    },
    showScore() {
      if (!this.content) return false;
      return this.content.is_show_score != 0;
    },
    scoreLevel() {
      if (!this.showScore) return "neutral";
      const score = Number(this.content.score);
      const pass = this.content.exam_info && this.content.exam_info.pass;
      if (pass != null && !isNaN(score) && score >= Number(pass)) return "pass";
      if (!isNaN(score) && score > 0) return "warn";
      return "fail";
    },
  },
  mounted() {
    this.typeIndex = this.$route.query.type;
    this.getTextContent();
  },
  methods: {
    ...mapMutations(["ShowTipModal"]),
    getTextContent() {
      const url =
        this.typeIndex == 1
          ? "/v1/personal/examRecord"
          : "/v1/openClass/examRecord";

      this.$axios
        .post(url, { record_id: this.$route.query.id }, { useLog: true })
        .then((res) => {
          if (res.code == 0) {
            this.content = res.data;
            this.selectedDta = res.data.record || [];
          } else {
            this.ShowTipModal({
              text: res.msg,
              fun: function () {
                this.$router.push(
                  "/learnCenter/list?data=" + this.$route.query.state
                );
              },
            });
          }
        });
    },
    questionTypeText(type) {
      const map = { 1: "单选题", 2: "多选题", 3: "判断题" };
      return map[type] || "题目";
    },
    getSelectOptions(timu) {
      const sd = timu.selectdata;
      if (Array.isArray(sd)) return sd;
      if (sd && typeof sd === "object") {
        return Object.keys(sd).map((key) => ({ key, value: sd[key] }));
      }
      return [];
    },
    normalizeAnswer(val, options) {
      if (val == null || val === "") return [];
      if (Array.isArray(val)) return val.map(String);

      const str = String(val).trim();
      const optionKeys = options ? options.map((o) => String(o.key)) : [];

      // 逗号、顿号、空格分隔：A,B,C
      if (/[,，、\s]/.test(str)) {
        return str.split(/[,，、\s]+/).filter(Boolean);
      }

      // 完整匹配单个选项 key
      if (optionKeys.includes(str)) {
        return [str];
      }

      // 多选连续拼接：ABC → ['A','B','C']
      if (optionKeys.length && str.length > 1) {
        const chars = str.split("");
        if (chars.every((c) => optionKeys.includes(c))) {
          return chars;
        }
      }

      return str ? [str] : [];
    },
    formatAnswer(val, timu) {
      const options = timu ? this.getSelectOptions(timu) : [];
      const arr = this.normalizeAnswer(val, options);
      return arr.length ? arr.join("、") : "";
    },
    isOptionSelected(timu, key) {
      const options = this.getSelectOptions(timu);
      return this.normalizeAnswer(timu.user_answer, options).includes(String(key));
    },
    isCorrectOption(timu, key) {
      const options = this.getSelectOptions(timu);
      return this.normalizeAnswer(timu.answer, options).includes(String(key));
    },
    getOptionClass(timu, key) {
      const selected = this.isOptionSelected(timu, key);
      const correct = this.isCorrectOption(timu, key);
      return {
        "is-selected": selected,
        "is-correct-opt": correct && timu.is_right == 1,
        "is-wrong-opt": selected && timu.is_right == 0 && !correct,
        "is-answer-opt": correct && timu.is_right == 0,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.exam-detail {
  min-height: 400px;
}

.exam-detail-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

/* ── 左侧成绩面板 ── */
.score-panel {
  flex-shrink: 0;
  width: 220px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 16px rgba(0, 12, 40, 0.08);
  padding: 28px 20px 24px;
  position: sticky;
  top: 20px;
}

.score-card {
  text-align: center;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f2f5;
}

.score-ring {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 4px solid #e8eaf0;
  background: #fafbfc;

  &.pass {
    border-color: #52c41a;
    background: linear-gradient(135deg, #f6ffed 0%, #fff 100%);
    .score-num { color: #389e0d; }
  }
  &.warn {
    border-color: #faad14;
    background: linear-gradient(135deg, #fffbe6 0%, #fff 100%);
    .score-num { color: #d48806; }
  }
  &.fail {
    border-color: #ff4d4f;
    background: linear-gradient(135deg, #fff1f0 0%, #fff 100%);
    .score-num { color: #cf1322; }
  }
  &.neutral {
    border-color: #d9d9d9;
    .score-num { color: #8c8c8c; }
  }
}

.score-num {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
  color: #254ed4;
}

.score-unit {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.score-title {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.score-stats {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px 0;
  border-bottom: 1px solid #f0f2f5;
}

.stat-item {
  text-align: center;
  flex: 1;

  .stat-num {
    display: block;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
  }
  .stat-label {
    display: block;
    font-size: 11px;
    color: #999;
    margin-top: 4px;
  }
}

.stat-correct .stat-num { color: #52c41a; }
.stat-wrong .stat-num { color: #ff4d4f; }
.stat-total .stat-num { color: #254ed4; }

.stat-divider {
  width: 1px;
  height: 28px;
  background: #f0f2f5;
}

.meta-list {
  list-style: none;
  margin: 0;
  padding: 16px 0 0;

  li {
    margin-bottom: 12px;

    &:last-child { margin-bottom: 0; }
  }

  .meta-label {
    display: block;
    font-size: 11px;
    color: #999;
    margin-bottom: 4px;
  }

  .meta-value {
    display: block;
    font-size: 12px;
    color: #333;
    line-height: 1.5;
    word-break: break-all;
  }
}

/* ── 右侧题目面板 ── */
.questions-panel {
  flex: 1;
  min-width: 0;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 4px;
}

.panel-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
}

.panel-badge {
  font-size: 12px;
  color: #666;
  background: #f0f2f5;
  padding: 4px 12px;
  border-radius: 20px;
}

.question-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 12, 40, 0.06);
  padding: 24px;
  margin-bottom: 16px;
  border-left: 4px solid transparent;
  transition: box-shadow 0.2s;

  &.is-correct { border-left-color: #52c41a; }
  &.is-wrong { border-left-color: #ff4d4f; }

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 12, 40, 0.1);
  }
}

.question-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}

.question-no {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #254ed4;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
}

.question-main {
  flex: 1;
  min-width: 0;
}

.question-title {
  font-size: 15px;
  font-weight: 500;
  color: #1a1a2e;
  line-height: 1.6;
  margin: 0 0 8px;
}

.question-meta {
  display: flex;
  gap: 8px;
}

.type-tag,
.mark-tag {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
}

.type-tag {
  background: #eef2ff;
  color: #254ed4;
}

.mark-tag {
  background: #f5f5f5;
  color: #888;
}

.result-badge {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 4px;

  &.badge-correct {
    background: #f6ffed;
    color: #389e0d;
    border: 1px solid #b7eb8f;
  }
  &.badge-wrong {
    background: #fff1f0;
    color: #cf1322;
    border: 1px solid #ffa39e;
  }
}

/* ── 选项 ── */
.options-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e8eaf0;
  background: #fafbfc;
  transition: all 0.15s;

  &.is-selected {
    border-color: #254ed4;
    background: #eef2ff;
  }
  &.is-correct-opt {
    border-color: #52c41a;
    background: #f6ffed;
  }
  &.is-wrong-opt {
    border-color: #ff4d4f;
    background: #fff1f0;
  }
  &.is-answer-opt {
    border-color: #52c41a;
    background: #f6ffed;
  }
}

.option-key {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #d9d9d9;
  font-size: 12px;
  font-weight: 600;
  color: #666;
}

.is-selected .option-key,
.is-correct-opt .option-key {
  background: #254ed4;
  border-color: #254ed4;
  color: #fff;
}

.is-wrong-opt .option-key {
  background: #ff4d4f;
  border-color: #ff4d4f;
  color: #fff;
}

.is-answer-opt .option-key {
  background: #52c41a;
  border-color: #52c41a;
  color: #fff;
}

.option-text {
  flex: 1;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.option-flag {
  flex-shrink: 0;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;

  &.user-flag {
    background: #eef2ff;
    color: #254ed4;
  }
  &.answer-flag {
    background: #f6ffed;
    color: #389e0d;
  }
}

.question-footer {
  margin-top: 16px;
  padding: 12px 16px;
  background: #fafbfc;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.6;

  .footer-label {
    color: #999;
  }
  .footer-answer {
    color: #52c41a;
    font-weight: 600;
    margin-right: 8px;

    &.user {
      color: #ff4d4f;
    }
  }
  .footer-sep {
    color: #ddd;
    margin: 0 8px;
  }
}

.empty-questions {
  text-align: center;
  padding: 60px 0;
  color: #999;
  font-size: 14px;
  background: #fff;
  border-radius: 10px;
}

.exam-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 80px 0;
  color: #999;
  font-size: 14px;
}

.loading-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #254ed4;
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.3; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1); }
}
</style>
